import { render, staticRenderFns } from "./GeneralConfigurations.vue?vue&type=template&id=6d5c979e&"
import script from "./GeneralConfigurations.vue?vue&type=script&lang=ts&"
export * from "./GeneralConfigurations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.0_babel-core@7.0.0-bridge.0_@babel+core@7.8.4_supports-color@6.1.0___ca_954b896a4cbf29da1b205b1ff899e628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/.pnpm/vuetify-loader@1.4.3_vue-template-compiler@2.6.11_vuetify@2.6.1_vue@2.6.11__webpack@4.41.6_supports-color@6.1.0_/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDialog,VRow})
